import styled from 'styled-components'
import logo from './assets/logo-bonbonbaby.png'

export const SiderDesktop = styled.div`
  display: flex;
  position: relative;
  z-index: 100;

  @media (max-width: 760px) {
    display: none;
  }

  .ant-layout-sider-children {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    overflow-x: hidden;
  }

  .ant-layout-sider {
    width: 280px !important;
    max-width: 280px !important;
    min-width: 280px !important;

    &.ant-layout-sider-collapsed {
      width: 90px !important;
      max-width: 90px !important;
      min-width: 90px !important;
    }
    .ant-menu-title-content {
      font-size: 1rem;
    }
    .ant-card-body {
      padding: 18px;
    }
    .ant-menu-inline-collapsed >.ant-menu-item {
      padding-inline: 25px;
    }

    .ant-card-meta-description {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }
  }

  .ant-menu-submenu-title {
    padding-inline: 25px !important;
  }

  .version-text {
    text-align: right;
    padding: 4 8;
    font-size: 0.55rem;
    font-weight: 400;
    color: var(--gray);
  }
`

export const SiderMobile = styled.div<{ $isSideMenuOpen: boolean }>`
  display: flex;
  position: relative;
  z-index: 100;

  @media (min-width: 760px) {
    display: none;
  }

  &::after {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width:  ${({ $isSideMenuOpen }) => ($isSideMenuOpen ? '100vw' : '0')};
    visibility:  ${({ $isSideMenuOpen }) => ($isSideMenuOpen ? 'visibile' : 'hidden')};
    height: 100dvh;
    background-color: rgba(0, 0, 0, 0.4);
    /* pointer-events: none; */
    z-index: -1;
    transition: visibility 0.6s ease-in-out;
  }

  .ant-layout-sider-children {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    width: 100%;
    height: 100dvh;
    overflow-y: auto;
  }
  .ant-layout-sider {
    width: 90vw !important;
    max-width: 90vw !important;
    min-width: 90vw !important;

    &.ant-layout-sider-collapsed {
      width: 0px !important;
      max-width: 0px !important;
      min-width: 0px !important;
    }
    .ant-menu-title-content {
      font-size: 1rem;
    }
    .ant-card-body {
      padding: 18px;
    }
    .ant-menu-inline-collapsed >.ant-menu-item {
      padding-inline: 25px;
    }
  }
  .version-text {
    text-align: right;
    padding: 4 8;
    font-size: 0.55rem;
    font-weight: 400;
    color: var(--gray);
  }
`

export const Logo = styled.div`
    width: 140px;
    height: 140px;
    background-image: url(${logo});
    background-position: center;
    background-repeat: no-repeat;
    background-size: 60%;
    background-color: #13569a;
    padding: 8px;
    margin: 0 auto;
    border-radius: 50%;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12), 0 4px 8px rgba(0, 0, 0, 0.08);
    border: 3px solid rgba(255, 255, 255, 0.9);
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    
    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 12px 32px rgba(0, 0, 0, 0.15), 0 6px 12px rgba(0, 0, 0, 0.1);
    }
`

export const BrandContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 24px;
`

export const BrandTitle = styled.h2`
    font-family: var(--font-primary);
    font-size: 1.5rem;
    font-weight: 700;
    color: #555;
    margin: 16px 0 8px 0;
    text-align: center;
    letter-spacing: 1px;
`

export const BrandDescription = styled.p`
    font-family: var(--font-primary);
    font-size: 0.875rem;
    color: #666;
    margin: 0;
    text-align: center;
    line-height: 1.4;
    padding: 0 20px;
`
